import Repository from "./Repository";

const sales_resource = "bills";
const warehousebills_resource = "warehouse_bills";
export default {
  billsModel(payload) {
    return Repository.post(sales_resource, payload);
  },
  warehousebillsModel(payload) {
    return Repository.post(warehousebills_resource, payload);
  },
};
